import { render, staticRenderFns } from "./receivedRequestsTable.vue?vue&type=template&id=335ec865"
import script from "./receivedRequestsTable.vue?vue&type=script&lang=js"
export * from "./receivedRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports